<template>
  <v-flex>
    <v-flex class="pb-2">
      <div class="container-input text-xs-left">
        <label class="area-label">LABEL DOCUMENT:</label>
        <input
          v-model="documentLabel"
          type="text"
          class="label-input"
          :class="{'showError': showError && !documentLabel}"
        >
      </div>
      <span v-if="showError && !documentLabel" class="error-message">*required field</span>
    </v-flex>
    <v-flex class="document-image documents">
      <file-uploader v-if="!newDocument" v-model="newDocument" filetype="image/x-png, image/gif, image/jpeg, .pdf, .doc, .docx">
        <template v-slot:activator>
          <div class="add-doc-container add" :class="{'showError-redBorder': showError}">
            <v-icon
              :color="colors.hwayzGray"
              size="48"
            >
              fa-cloud-upload-alt
            </v-icon>
            <label>Drag and Drop</label>
            <label>or</label>
            <label>browse</label>
          </div>
        </template>
      </file-uploader>
      <v-flex v-else class="documents document-image">
        <div
          v-if="documentsArray"
          class="document-image-placeholder"
        >
          <iframe
            v-if="checkType()"
            :src="documentsArray.fileURL"
          />
          <img v-else :src="documentsArray.fileURL">
        </div>
      </v-flex>
    </v-flex>
    <v-btn
      class="submit-button"
      :color="colors.hwayzBrandBlue"
      @click="updateDocument()"
    >
      UPLOAD DOCUMENT
    </v-btn>
  </v-flex>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
import { uploadDocument } from '../../services/profile'
import colors from '../../scss/_colors.scss'
import FileUploader from '../uiUtils/FileUploader'
export default {
  components: {
    FileUploader
  },
  props: {
    profile: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      colors,
      documentLabel: '',
      newDocument: null,
      documentsArray: null,
      showError: false
    }
  },
  computed: {
    ...mapState('style', ['modal'])
  },
  watch: {
    profile() {
      this.mapDocuments()
    },
    newDocument() {
      this.mapDocuments()
    }
  },
  created() {
    this.mapDocuments()
  },
  methods: {
    ...mapMutations('client', {
      setClientData: 'SET_CLIENT_DATA'
    }),
    mapDocuments() {
      if (this.newDocument && this.newDocument.newFile) {
        this.documentsArray = this.newDocument
      }
    },
    async updateDocument() {
      if (this.newDocument && this.newDocument.newFile && this.documentLabel) {
        const formData = new FormData()
        formData.append('upload', this.newDocument.newFile)
        const updatedDocuments = await uploadDocument(this.profile, 'user_documents', this.documentLabel, formData)
        this.setClientData(updatedDocuments)
        this.closeUpdateDocsModal()
      } else {
        this.showError = true
      }
    },
    closeUpdateDocsModal() {
      this.newDocument = null
      this.documentLabel = null
      this.showError = false
      this.$emit('close-modal')
    },
    checkType() {
      return this.documentsArray.newFile.name.includes('.pdf') || this.documentsArray.newFile.name.includes('.doc')
    }
  }
}
</script>
<style lang="sass" scoped>
.area-label
  display: block
  text-transform: capitalize
  font-size: $hwayzFont1rem
  font-weight: 450
.container-input
  display: flex
  flex-direction: row
  justify-content: flex-start
  align-items: center
.label-input
  width: 60%
  display: block
  font-size: 1.4rem
  border-bottom: 0.1rem $color-grey solid
  margin-left: 10px
.v-btn
  font-weight: 500 !important
.showError
  border-bottom: 0.1rem red solid
  &-redBorder
    border: 0.1rem red solid !important
.error-message
  color: red
  font-size: 1rem
</style>
<style lang="sass">
.submit-button
  width: 100%
  border-radius: 3px
  font-size: 1.2rem
  margin: 1rem auto!important
  color: $hwayzWhite !important
.submit-button:hover
  background-color: $hwayzBrandGold !important
.add-doc-container label
  display: block
  color: $color-grey
.add-doc-container .v-icon
  margin-bottom: 1rem
.modal-close
  @extend %modal__button-close, %disable-selection
iframe
  border: none
.documents
  display: flex
  flex-direction: row
  justify-content: center
  flex-wrap: wrap
  scroll-y: auto
.documents label span
  font-size: 1rem
  color: $hwayzMediumGray
.document-image
  transition: 0.5s all
  cursor: pointer
  height: 20%
  width: 100%
  div
    margin: 0.5rem

  &-placeholder, .add
    display: flex
    flex-flow: column
    align-items: center
    justify-content: center
    margin: 0 auto
    position: relative

  &-placeholder
      height: 13rem
      width: 9rem
      border: .1rem solid $hwayzce
  .add
    height: 16rem
    width: 13rem
    border: .1rem solid $hwayzce
  img, iframe
    width: 100%
    height: 100%
  .image-hover
    pointer-events: none
    position: absolute
    bottom: 0
    top: 0
    left: 0
    right: 0
    margin: 0 !important
    background-color: $hwayzMediumGray
    opacity: 0.9
    color: $hwayzWhite
    .hover-icon
      pointer-events: all
      font-size: $hwayzFont1rem6
      position: absolute
      top: 0.5rem
      right: 0.5rem
      cursor: pointer
</style>
